<template>
  <div class="main-dashboard-panel event-list-page">
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            Showrooms
          </h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <div class="container-fluid pane events-list-pane">
      <EventListTable v-loading="fetchInProgress" :events="events" />

      <br />

      <Fab v-if="user.isOrganizer || user.isAdmin" ref="fab">
        <el-button
          type="primary"
          class="create-btn pull-right"
          @click="$refs.createDialog.open()"
        >
          Create showroom
        </el-button>
      </Fab>

      <EventCreateDialog
        ref="createDialog"
        :organization-id="user.organizationId"
        @created="fetch()"
      />
    </div>
  </div>
</template>

<script>
import EventListTable from './EventListTable.vue'
import EventCreateDialog from './EventCreateDialog.vue'
import Fab from 'components/common/FAB.vue'
import { mapState } from 'vuex'
import { setTimeout } from 'timers'

export default {
  components: { EventCreateDialog, EventListTable, Fab },
  props: {
    organizationId: { type: String, default: '' },
  },
  computed: {
    ...mapState({
      user: (s) => s.user.data,
      events: (s) => s.eventList.events,
      fetchInProgress: (s) => s.eventList.fetchInProgress,
    }),
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('eventList/fetch')
      this.$nextTick(() => {
        if (this.$refs.fab) {
          this.$refs.fab.update()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.events-list-pane {
  padding-bottom: 50px;
}
</style>
